import type {UseMutationResult} from 'react-query';
import {useMutation, useQueryClient} from 'react-query';
import {apiUrl} from '@/utils/api';
import {type CourseApproval} from '@/types/CourseApproval';

type Props = {
    jwt : string;
    courseYearMaterialApprovalIds : string[];
    sectionMaterialApprovalIds : string[];
};

type ApproveSelectedCoursesResponse = {
    data: CourseApproval[];
    errorCode: number;
    message: string;
};

export const useApproveSelectedCourses = () : UseMutationResult<ApproveSelectedCoursesResponse, unknown, Props> => {
    const queryClient = useQueryClient();

    return useMutation(async ({jwt, courseYearMaterialApprovalIds, sectionMaterialApprovalIds} : Props) => {
        const response = await fetch(apiUrl(`/v1/course-approval/approve`).toString(), {
            method: 'PUT',
            body: JSON.stringify({
                courseYearMaterialApprovalIds: courseYearMaterialApprovalIds,
                sectionMaterialApprovalIds: sectionMaterialApprovalIds,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`,
            },
        });

        if (!response.ok) {
            throw new Error('Unable to update selected course approvals.');
        }

        return (await response.json() as ApproveSelectedCoursesResponse);
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries([`course-approvals`]);
        },
    });
};
